import React from "react"
import { useSiteMetadata } from "../hooks/site-meta"
import thumbnail from "../../assets/media/default-thumbnail.jpg"
import { getImage } from "gatsby-plugin-image"

export const Seo = ({ title, description, image, pathname, children, attributes, type }) => {
    const { defaultTitle, defaultDescription, defaultType, siteUrl, author: defaultAuthor, twitterUsername } = useSiteMetadata()

    const { published, modified, author, review } = attributes

    const seo = {
        title: title || defaultTitle,
        author: author || defaultAuthor,
        description: description || defaultDescription,
        image: `${siteUrl}${image ? image?.images.fallback.src : thumbnail}`,
        url: `${siteUrl}${pathname || ``}`,
        twitterUsername,
        type: type || defaultType,
    }

    // Standard Structured Data.
    const structuredData = {
        "@context": "https://schema.org/",
        "@type": seo.type,
        "headline": seo.title,
        "image": seo.image,
        "author": {
            "@type": "Person",
            "name": seo.author
        },
        "publisher": {
            "@id": siteUrl
        },
        "datePublished": published,
        "description": seo.description,
    }
    // Add last modified date if available.
    if (modified) {
        structuredData.dateModified = modified
    }
    // Custom Review schema.
    if ("Review" === seo.type) {
        const logo = getImage(review.logo)

        structuredData.reviewRating = {
            "@type": seo.type,
            "ratingValue": review.rating,
            "worstRating": 1,
            "bestRating": 5,
        }
        structuredData.itemReviewed = {
            "@type": "Organization",
            "name": review.name,
            "description": review.description,
            "legalName": review.legalName,
            "image": `${siteUrl}${logo.images.fallback.src}`,
        }
    }
    if ("Course" === seo.type) {
        structuredData.name = seo.title
        structuredData.provider = {
            "@type": "Organization",
            "name": "Vegas Aces",
            "sameAs": siteUrl
        }
        structuredData.hasCourseInstance = {
            "@type": "CourseInstance",
            "courseWorkload": "PT1H",
            "courseMode": [
                "online"
            ]
        }
        structuredData.offers = {
            "@type": "Offer",
            "price": "0",
            "priceCurrency": "USD",
            "category": "Free",
        }
    }

    return (
        <>
            <title>{seo.title}</title>
            <meta property="og:type" content="website"></meta>
            <meta property="twitter:domain" content="www.vegas-aces.com" />
            <meta name="description" content={seo.description} />
            <meta name="image" content={seo.image} />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={seo.title} />
            <meta name="twitter:url" content={seo.url} />
            <meta name="twitter:description" content={seo.description} />
            <meta name="twitter:image" content={seo.image} />
            <meta name="twitter:creator" content={seo.twitterUsername} />
            {children}
            <script type="application/ld+json">{JSON.stringify(structuredData)}</script>
        </>
    )
}
